import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../../environments/environment';

export interface IHeadline {
    internalName: string;
    displayName: string;
}

interface SignedUrlDto {
    signedURL: string;
}

@Injectable()
export class FileService {
    private readonly http = inject(HttpClient);

    locationInformationCSVColumns: IHeadline[] = [
        { internalName: 'homeAddress.name', displayName: 'Name' },
        { internalName: 'homeAddress.street', displayName: 'Straße' }
    ];

    locationDataCSVColumns: IHeadline[] = [
        { internalName: 'country.name', displayName: 'Country' },
        { internalName: 'address.city', displayName: 'City' },
        { internalName: 'locationCode', displayName: 'Locality_Name' },
        { internalName: 'company.nameShort', displayName: 'Organization' },
        { internalName: 'company.name', displayName: 'Company_1' },
        { internalName: 'company.corporateType', displayName: 'character of Co' }
    ];

    locationDataCSVColumnsAdvancedUser: IHeadline[] = [
        { internalName: 'company.name', displayName: 'Company_1' },
        { internalName: 'address.street', displayName: 'Street' },
        { internalName: 'address.postalCode', displayName: 'ZIP Code' },
        { internalName: 'address.city', displayName: 'City' },
        { internalName: 'country.name', displayName: 'Country' },
        { internalName: 'company.nameShort', displayName: 'Organization' },
        { internalName: 'locationCode', displayName: 'Locality_Name' },
        { internalName: 'salId', displayName: 'ID' },
        { internalName: 'company.corporateType', displayName: 'character of Co' },
        { internalName: 'company.isHeadquarters', displayName: 'Ges. Head' }
    ];

    public async getDocumentSignedUrl(key: string): Promise<string | false> {
        try {
            const response = await firstValueFrom(
                this.http.post<SignedUrlDto>(`${environment.endpoint}/document`, { key })
            );
            return response.signedURL;
        } catch (error: unknown) {
            console.error('Error reading document:', error);
            return false;
        }
    }

    jsonToCSV(json: Array<object>, isAdvancedUser: boolean): void {
        const displayHeader = isAdvancedUser ? this.locationDataCSVColumnsAdvancedUser : this.locationDataCSVColumns;
        let outputString = '';
        const seperator = '|';
        // console.log(json);

        for (const element of displayHeader) {
            outputString += element.displayName + seperator;
        }
        outputString = outputString.substring(0, outputString.length - 1);
        outputString += '\r\n';
        for (const element of json) {
            for (const element2 of displayHeader) {
                const keys = element2.internalName.split('.');
                let curElement: any = element;
                for (const key of keys) {
                    const matches = key.match(/\[(.*?)\]/);
                    curElement = matches ? curElement[key.substr(0, key.indexOf('['))][matches[1]] : curElement[key];
                    if (!curElement) {
                        curElement = "''";
                    }
                }
                outputString += curElement + seperator;
            }
            outputString = outputString.substring(0, outputString.length - 1);
            outputString += '\r\n';
        }
        this.downloadCSV(outputString);
    }

    downloadCSV(csvFile: any) {
        const filename = 'SAL_export.csv';
        const link = document.createElement('a');
        if (link.download !== undefined) {
            link.setAttribute('href', 'data:text/csv;charset=utf-8,%EF%BB%BF' + encodeURIComponent(csvFile));
            link.setAttribute('download', filename);
            link.style.visibility = 'hidden';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    }
}
